/* ヘルプメッセージ, バリデーション */
import React from 'react';
import HelpMessage from '../atoms/HelpMessage';
import ValidMessage from '../atoms/ValidMessage';

interface Props {
  help_msg?: string;
  valid_msg?: string;
}

const Messages: React.FC<Props> = ({ help_msg, valid_msg }) => {
  return (
    <>
      <ValidMessage message={valid_msg} />
      <HelpMessage help_msg={help_msg} />
    </>
  );
};

export default Messages;
